import script from "./kalio-demodev-registration.vue?vue&type=script&setup=true&lang=js"
export * from "./kalio-demodev-registration.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__